export default "/images/vendor/flag-icons/flags/1x1/tc.svg?f521df6fee171a65a904d313b52ea36b";